import { useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router";

import { Typography, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { CustomWidthTooltip } from "mui-toolkit/CustomWidthTooltip";
import DeleteConfirmationButton from "mui-toolkit/DeleteConfirmationButton";
import { formatPercentage } from "utility/formatters";

import { EditIcon } from "../../../Icons/Icons";

export default function ProducerFarmBaseAcreDataTable({
  producerFarm,
  producerFarmBaseAcres,
  isLoading,
  pageSizes = [5, 10, 25, 50, 100],
  rowHeight = 80,
  onChange,
}) {
  const navigate = useNavigate();
  const { crop_year } = useParams();

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), { noSsr: true });

  const COLUMNS_PRODUCERFARMBASEACRES = useMemo(
    () => [
      {
        field: "commodity_name",
        headerName: "Commodity",
        flex: 1,
        renderCell: (params) => (
          <Typography
            color="primary"
            component={Link}
            to={`/vault/${crop_year}/${producerFarm?.location_state_name}/${producerFarm?.location_county_name}/${producerFarm?.id}/baseAcre/${params.row.id}`}
          >
            {params.value}
          </Typography>
        ),
      },
      {
        field: "crop_year",
        headerName: "Year",
        flex: 1,
      },
      {
        field: "base_acreage",
        headerName: "Acres",
        flex: 1,
      },
      {
        field: "plc_yield",
        headerName: "PLC Yield",
        flex: 1,
      },
      {
        field: "share_percent",
        headerName: "Share %",
        flex: 1,
        valueFormatter: (value) => (value ? formatPercentage(value, 0) : ""),
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        headerAlign: "right",
        align: "right",
        width: 100,
        sortable: false,
        getActions: (params) => [
          <CustomWidthTooltip key="delete" title="Delete" placement="top" arrow>
            <DeleteConfirmationButton item={params.row} onChange={onChange} />
          </CustomWidthTooltip>,

          <CustomWidthTooltip key="edit" title="Edit" placement="top" arrow>
            <GridActionsCellItem
              key="view"
              icon={<EditIcon />}
              label="View Details"
              onClick={() => {
                navigate(
                  `/vault/${crop_year}/${producerFarm?.location_state_name}/${producerFarm?.location_county_name}/${producerFarm?.id}/baseAcre/${params.row.id}`
                );
              }}
            />
          </CustomWidthTooltip>,
        ],
        flex: isMobile ? 2 : 0,
      },
    ],
    [crop_year, navigate, producerFarm, isMobile]
  );

  return (
    <>
      <TilleyDataGrid
        rows={producerFarmBaseAcres || []}
        columns={COLUMNS_PRODUCERFARMBASEACRES}
        pageSizeOptions={pageSizes}
        defaultPageSize={isMobile ? 5 : 10}
        gridKey="producer-farm-base-acres"
        getRowId={(row) => row.id}
        rowHeight={rowHeight}
        isLoading={isLoading}
        sx={{ width: "99%", boxSizing: "border-box" }}
      />
    </>
  );
}
